import React, { FC, SyntheticEvent, useState, useEffect } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import useCredentials from '../../hooks/useCredentials'

interface Props {
  benefitId?: string
  onSaveSuccess?: () => void
  initialContent?: string
  noteId?: number
}

const NewBenefitNoteForm: FC<Props> = ({ benefitId, onSaveSuccess, initialContent = '', noteId }) => {
  const { credentials } = useCredentials()
  const [noteText, setNoteText] = useState<string>(initialContent)
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [submitError, setSubmitError] = useState<string>('')

  useEffect(() => {
    setNoteText(initialContent)
  }, [initialContent])

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault()
    setSubmitting(true)
    try {
      setSubmitError('')
      const data = new FormData()
      data.append('content', noteText)
      if (initialContent && noteId) {
        // Update existing note
        await axios.put(`/api/panel/benefits/${benefitId}/notes/${noteId}`, data, {
          headers: credentials,
        })
      } else {
        // Create new note
        await axios.post(`/api/panel/benefits/${benefitId}/notes`, data, {
          headers: credentials,
        })
      }
      onSaveSuccess?.()
    } catch (e: any) {
      setSubmitError(e?.message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} autoComplete='off' data-note-id={noteId}>
      <div className='field'>
        <div className='control'>
          <div className='control'>
            <CKEditor
              editor={ClassicEditor}
              data={noteText}
              config={{
                toolbar: {
                  items: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'link',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'outdent',
                    'indent',
                    '|',
                    'blockQuote',
                    'insertTable',
                    'mediaEmbed',
                    'undo',
                    'redo',
                  ],
                },
              }}
              onChange={(event, editor) => {
                setNoteText(editor.getData())
              }}
            />
          </div>
        </div>
      </div>
      <div className='field'>
        <button className={`button is-primary ${submitting && 'is-loading'}`} type='submit' disabled={submitting}>
          {initialContent ? 'Update' : 'Save'}
        </button>
        {submitError && <div className='has-text-danger mt-2'>{submitError}</div>}
      </div>
    </form>
  )
}

export default NewBenefitNoteForm

